import { HelichrysumIcon } from "@/components/brand/HelichrysumIcon";

const ITEMS = ["Battericida", "Fungicida", "Attivo contro il 2-nonenale", "Antinfiammatorio", "Antiallergico", "Con postbiotici dell'elicriso"];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {ITEMS.map((t) => (
      <span key={t} className="flex items-center gap-10 px-5 font-display text-4xl italic text-navy sm:text-5xl lg:text-6xl">
        {t}
        <HelichrysumIcon className="h-9 w-9 text-gold lg:h-11 lg:w-11" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section aria-label="Le proprietà della linea Perfero" className="overflow-hidden border-y border-copper/25 bg-cream py-8 lg:py-11" data-testid="claims-marquee">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row hidden />
    </div>
  </section>
);
